import { Reducer } from "react";
import { INewManagedTenantState } from "./types/INewManagedTenantState";
import { WizardAction } from "./types/wizardActions";

export interface IUpdateWizardAction {
  action: WizardAction;
  newState: INewManagedTenantState;
}

export const wizardStateReducer: Reducer<INewManagedTenantState, IUpdateWizardAction> = (
  state,
  updateAction
): INewManagedTenantState => {
  if (!updateAction || !updateAction.newState) {
    return state;
  }

  let newState: INewManagedTenantState = { ...state };

  switch (updateAction.action) {
    case "usePasswordFlow":
      newState.usePasswordFlow = updateAction.newState.usePasswordFlow;
      if (!newState.usePasswordFlow) {
        if (newState.errors) {
          delete newState.errors.password;
        }
        delete newState.password;
      }

      if (newState.tenantError) {
        delete newState.tenantError;
      }
      break;

    case "setCredential":
      if (updateAction.newState.account !== undefined) {
        newState.account = updateAction.newState.account;
      }

      if (updateAction.newState.password !== undefined) {
        newState.password = updateAction.newState.password;
      }

      newState.errors = updateAction.newState.errors;
      newState.isCredentialTouched = true;
      break;

    case "setTenantError":
      newState.tenantError = updateAction.newState.tenantError;
      break;

    case "setCreateError":
      newState.createError = updateAction.newState.createError;
      break;

    // Microsoft Entra ID
    case "setConsentError":
      newState.consentError = updateAction.newState.consentError;
      break;
    case "setServerError":
      newState.serverError = updateAction.newState.serverError;
      break;
    case "setConsentState":
      newState.consentState = updateAction.newState.consentState;
      break;
    case "setTenant":
      const { tenant } = updateAction.newState;
      newState.tenant = tenant;
      newState.tenantError = undefined;
      break;

    case "setPredefinedJobs":
      newState.predefinedJobs = updateAction.newState.predefinedJobs;
      break;
    case "setGrantUrl":
      newState.grantUrl = updateAction.newState.grantUrl;
      break;
    case "setAzureADRefreshToken":
      newState.refreshToken = updateAction.newState.refreshToken;
      break;
    case "setAADDeviceCodeResponse":
      newState.aadDeviceCodeResponse = updateAction.newState.aadDeviceCodeResponse;
      newState.aadDeviceCodeRequest = undefined;
      break;
    case "setAADDeviceCodeRequest":
      newState.aadDeviceCodeRequest = updateAction.newState.aadDeviceCodeRequest;
      newState.aadDeviceCodeResponse = undefined;
      break;
    case "setAADOneTimeCodeError":
      newState.aadOneTimeErrorCode = updateAction.newState.aadOneTimeErrorCode;
      newState.aadDeviceCodeError = updateAction.newState.aadDeviceCodeError;
      break;
    case "setAADDeviceCodeError":
      newState.aadDeviceCodeError = updateAction.newState.aadDeviceCodeError;
      break;

    // ex online
    case "setEOADeviceCodeResponse":
      newState.eoaDeviceCodeResponse = updateAction.newState.eoaDeviceCodeResponse;
      newState.eoaDeviceCodeRequest = undefined;
      break;
    case "setEOADeviceCodeRequest":
      newState.eoaDeviceCodeRequest = updateAction.newState.eoaDeviceCodeRequest;
      newState.eoaDeviceCodeResponse = undefined;
      break;
    case "setEOAOneTimeCodeError":
      newState.eoaOneTimeErrorCode = updateAction.newState.eoaOneTimeErrorCode;
      newState.eoaDeviceCodeError = updateAction.newState.eoaDeviceCodeError;
      break;
    case "setEOADeviceCodeError":
      newState.eoaDeviceCodeError = updateAction.newState.eoaDeviceCodeError;
      break;

    case "setConnectionType":
      newState.connectionIsRecommended = updateAction.newState.connectionIsRecommended;
      break;

    case "setSystemType":
      newState.systemTypes = { ...newState.systemTypes, ...updateAction.newState.systemTypes };
      break;

    case "setPrincipalAccountName":
      newState.principalAccountName = updateAction.newState.principalAccountName;
      break;

    case "setState":
      newState = { ...newState, ...updateAction.newState };
      break;

    default:
      break;
  }

  return newState;
};
